
export default {
    name: "HeaderSearch",
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            isInputVisible: this.isOpen,
        }
    },
    watch: {
        isOpen(value) {
            this.isInputVisible = value;
        }
    },
    methods: {
        toggleInput() {
            this.isInputVisible = !this.isInputVisible;
        }
    },
}
